/** Epic 5 — discrepancy dashboard with virtualised grid. */
export function DashboardPage() {
  return (
    <div>
      <p className="text-text-2 text-sm">Dashboard — Epic 5 implementation pending.</p>
    </div>
  );
}
